import React from 'react'
import { v4 as uuid } from 'uuid'
import { arrayUnion, doc, serverTimestamp, Timestamp, updateDoc } from 'firebase/firestore'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'
import { db, storage } from '../firebase'
import { Attachment } from '../icons'
import { useAuth } from '../contexts/AuthContext'
import { useChat } from '../contexts/ChatContext'

const Input = () => {
  const { user } = useAuth()
  const { cChat } = useChat()
  const [text, setText] = React.useState('')
  const [image, setImage] = React.useState(null)

  const handleSend = async () => {
    if (image) {
      const storageRef = ref(storage, uuid());
      const uploadTask = uploadBytesResumable(storageRef, image);

      uploadTask.on(
        (error) => {
          /* setSignupError('Failed to upload the image!') */
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then(async downloadURL => {
            await updateDoc(doc(db, 'chats', cChat.chatId), {
              messages: arrayUnion({
                id: uuid(),
                image: downloadURL,
                text,
                senderId: user.uid,
                date: Timestamp.now()
              })
            })
          })
        }
      )
    } else {
      await updateDoc(doc(db, 'chats', cChat.chatId), {
        messages: arrayUnion({
          id: uuid(),
          text,
          senderId: user.uid,
          date: Timestamp.now()
        })
      })
    }

    await updateDoc(doc(db, 'userChats', user.uid), {
      [cChat.chatId + '.date']: serverTimestamp(),
      [cChat.chatId + '.lastMessage']: {
        text
      }
    })

    await updateDoc(doc(db, 'userChats', cChat.user.uid), {
      [cChat.chatId + '.date']: serverTimestamp(),
      [cChat.chatId + '.lastMessage']: {
        text
      }
    })

    setText('')
    setImage(null)
  }

  return (
    <div className='flex gap-8 justify-between bg-white z-10 h-32 w-full px-8 py-5 shadow-inner fixed bottom-0 md:static'>
      <input type='text' placeholder='Type something...' className='grow p-5 basis-2/3 bg-gray-200 text-purple-light border-none placeholder:text-dark-20 focus:outline-none rounded-xl' value={text} onChange={(e) => setText(e.target.value)} />
      <div className='flex gap-4 items-center'>
        <input type='file' onChange={(e) => setImage(e.target.files[0])} id='attachment' className='hidden' />
        <label htmlFor='attachment' className='flex items-center gap-4 hover:cursor-pointer'>
          <img src={Attachment} alt='file-icon' className='h-16 w-16' />
        </label>
        <button className='px-8 py-4 md:px-10 md:py-5 text-3xl tracking-tighter bg-purple-light text-white rounded-xl' onClick={handleSend}>Send</button>
      </div>
    </div>
  )
}

export default Input